import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useIsCandidatoContratacao } from '@/hooks/useIsCandidatoContratacao';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
}

export function ProtectedRoute({ children, requireAuth = true }: ProtectedRouteProps) {
  const { user, loading: authLoading } = useAuth();
  const { isCandidato, isLoading: candLoading } = useIsCandidatoContratacao();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading) return;

    if (requireAuth && !user) {
      navigate('/auth');
      return;
    }

    // Bloqueio rígido: candidato ativo NUNCA acessa a intranet padrão.
    if (user && !candLoading && isCandidato) {
      navigate('/candidato', { replace: true });
    }
  }, [user, authLoading, candLoading, isCandidato, navigate, requireAuth]);

  if (authLoading || (user && candLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (requireAuth && !user) return null;
  if (isCandidato) return null;

  return <>{children}</>;
}
